import { cmToPx } from 'helpers/utils';
import style from './FenceElement.module.scss';

const FenceElementRail = ({ slats }) => {
  let gridItemStyle;
  let supporterItemStyle;

  if (slats.railDirection === 'horizontal') {
    gridItemStyle = { height: slats.size };
    supporterItemStyle = { width: cmToPx(6) };
  } else {
    gridItemStyle = { width: slats.size };
    supporterItemStyle = { height: cmToPx(6) };
  }

  return (
    <div className={`${style.rail} ${style['rail-' + slats.railColor]}`} style={{ height: slats.railHeight }}>
      <div className={style.rail_supporters} style={{ top: cmToPx(6), bottom: cmToPx(6) }}>
        <span style={supporterItemStyle}></span>
        <span style={supporterItemStyle}></span>
      </div>
      <div className={style.rail_grid} style={{ top: cmToPx(6), right: 0, bottom: cmToPx(6), left: 0 }}>
        {[...Array(slats.count)].map((slat, index) => (
          <span key={index} style={gridItemStyle}></span>
        ))}
      </div>
    </div>
  );
};

export default FenceElementRail;
